import swal from 'sweetalert'
import { privateAPI, privateAPIFormData } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'

export const createWhatsappTemplate = (payload) => {
  return async () => {
    await privateAPI.post('/whatsapp/create-template', { data: { ...payload } }).then((res) => {
      // dispatch(getMonitorings())
      swal('', res?.data?.message, 'success')
    })
  }
}

export const getWhatsappChannel = () => {
  return async () => {
    let res = await privateAPI.get('/whatsapp/get-channel')
    if (res?.data) {
      let resp = decrypt(res?.data)
      return resp?.data || []
    }
  }
}

export const getWhatsappTemplate = (payload) => {
  return async () => {
    let res = await privateAPI.post('/whatsapp/get-template', { data: { ...payload } })
    if (res?.data) {
      let resp = decrypt(res?.data)
      return resp?.data || []
    }
  }
}

export const getDataExcelLink = (payload) => {
  return async () => {
    let res = await privateAPI.post('/whatsapp/get-data-excel-link', {
      data: { ...payload },
    })
    if (res?.data) {
      let resp = decrypt(res?.data)
      return resp?.data || ''
    }
  }
}

export const createWhatsappCampaign = (payload) => {
  return async () => {
    try {
      let res = await privateAPIFormData.post('/whatsapp/create-campaign', payload)
      console.log('🚀 ~ file: whatsappAction.js:50 ~ return ~ res:', res.data)
      if (res?.data) {
        swal('', res?.data?.message, 'success')
        return res?.data || ''
      } else {
        swal('', res?.data?.message, 'error')
      }
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}
export const createWhatsappCampaignWithQuery = (payload) => {
  return async () => {
    try {
      let res = await privateAPIFormData.post('/whatsapp/create-campaign-with-query', payload)
      console.log('🚀 ~ file: whatsappAction.js:66 ~ return ~ res:', res.data)
      if (res?.data) {
        swal('', res?.data?.message, 'success')
        return res?.data || ''
      } else {
        swal('', res?.data?.message, 'error')
      }
    } catch (error) {
      swal('', error?.response?.data?.error, 'error')
    }
  }
}

export const createWhatsappMessage = (payload) => {
  return async () => {
    try {
      let res = await privateAPI.post('/whatsapp/sent-single-message', {
        data: { ...payload },
      })
      if (res?.data) {
        swal('', res?.data?.message, 'success')
        return res?.data || ''
      } else {
        swal('', res?.data?.message || 'Server Error', 'error')
      }
    } catch (error) {
      swal('', error?.response?.data?.error || 'Server Error', 'error')
    }
  }
}
